import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { isEmptyObject } from 'jquery';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import { Card, CardBody } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getMuiTheme, tableOptions } from '../../util/MuiTableTheme';
import { Panel } from '../../components/panel/panel.jsx';
import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Services from '../../services/service';


class ChecklistReportProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataChecklist: [],
      dataAsset: [],
      dateFrom: new Date(),
      dateTo: new Date(),
    }
  }

  componentDidMount() {
    this.getDataModule();
    this.getDataAsset();
  }

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Checklist Maintenance</li>
      </ol>
      <h1 className="page-header">Laporan Checklist Maintenance </h1>
    </div>
  );

  getDataModule = () => {
    const params = {
      dateFrom: moment(this.state.dateFrom).format("YYYY-MM-DD"),
      dateTo: moment(this.state.dateTo).format("YYYY-MM-DD")
    }
    Services.getAllJobList(params)
      .then(res => {
        this.setState({ dataChecklist: res });
      })
      .catch(err => console.log(err))
  }

  getDataAsset = () => {
    Services.getAsset()
      .then(res => {
        this.setState({ dataAsset: res });
      })
      .catch(err => console.log(err))
  };

  handleDateChange = (name, date) => {
    if(name === "dateFrom"){
      this.setState({[name]: date, dateTo: date}, this.getDataModule);
    }else{
      this.setState({[name]: date }, this.getDataModule);
    }
  };

  renderFilterDateSection = () => (
    <Card
      className="border-0 card-inverse text-white bg-dark"
      style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
    >
      <CardBody>
        <div className="row">
          <label className="col-form-label col-auto">Tanggal Mulai</label>
          <DatePicker
            className="col-auto form-control"
            dateFormat="dd/MM/yyyy"
            selected={this.state.dateFrom}
            onChange={(date) =>
              this.handleDateChange("dateFrom", date)
            }
            selectsStart
            startDate={this.state.dateFrom}
            endDate={this.state.dateTo}
            maxDate={moment().toDate()}
            onKeyDown={(e) => {
              e.preventDefault();
            }}
          />
          <label className="col-form-label col-auto ml-2">Tanggal Akhir</label>
          <DatePicker
            className="col-auto form-control"
            dateFormat="dd/MM/yyyy"
            selected={this.state.dateTo}
            onChange={(date) =>
              this.handleDateChange("dateTo", date)
            }
            selectsEnd
            startDate={this.state.dateFrom}
            endDate={this.state.dateTo}
            maxDate={moment(this.state.dateFrom).add(30, 'day').toDate()}
            onKeyDown={(e) => {
              e.preventDefault();
            }}
          />
        </div>
      </CardBody>
    </Card>
  );

  renderChecklistTable = () => {
    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "scheduleTypeName",
        label: "Tipe",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "moduleName",
        label: "Form Ceklist",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "divisionName",
        label: "Divisi Role",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "assetId",
        label: "Asset",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => {
            let assetFilter = this.state.dataAsset.find(item => item._id === value);
            if (assetFilter === undefined) return '';
            let assetName = isEmptyObject(assetFilter) && assetFilter.name === undefined ? '' : assetFilter.name;
            return assetName;

          }
        }
      },
      {
        name: "startDate",
        label: "Start Date",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => value ? moment(value).format('DD-MM-YYYY HH:mm') : "-"
        }
      },
      {
        name: "endDate",
        label: "End Date",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => value ? moment(value).format('DD-MM-YYYY HH:mm') : "-"
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "countTotalTime",
        label: "Timeline",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "job_id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px", maxWidth: "200px" } }),
          customBodyRender: (value) => {
            // console.log('xxx state', this.state.dataChecklist.find(item => item._id === value));
            return (
              <div className="with-btn text-nowrap">
                <Link
                  to={{
                    pathname: `/reporting/checklist-report-preview/`,
                    state: this.state.dataChecklist.find(item => item.job_id === value)
                  }}
                >
                  <button
                    className="btn btn-sm btn-success width-70">Detail</button>
                </Link>
              </div>
            );
          }
        }
      }
    ];

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List Checklist Maintenance"}
          data={this.state.dataChecklist}
          columns={columns}
          options={tableOptions}
        />
      </MuiThemeProvider>
    )
  };

  render() {
    return (
      <div>
        {this.renderBreadcrumb()}
        <Panel>
          {this.renderFilterDateSection()}
          {this.renderChecklistTable()}
        </Panel>
      </div>
    )
  }
}

export default withNotification(ChecklistReportProgress);